export default __webpack_public_path__ + "static/media/slide-next.46152fc7.svg";